declare const __API_URL__: string | undefined;

// Читаем runtime env (внедряемый через /env.js при старте Docker контейнера)
const runtimeApiUrl =
  typeof window !== "undefined" ? (window as any).__ENV__?.API_URL : undefined;

// Читаем build-time define (при сборке через bun build)
const buildTimeApiUrl =
  typeof __API_URL__ !== "undefined" && __API_URL__ ? __API_URL__ : undefined;

// Читаем process.env (для Bun / Node.js среды)
const processApiUrl =
  typeof process !== "undefined"
    ? process.env?.API_URL || process.env?.VITE_API_URL || process.env?.BACKEND_URL
    : undefined;

const rawUrl = runtimeApiUrl || buildTimeApiUrl || processApiUrl || "";

export const API_BASE_URL = rawUrl
  ? rawUrl.replace(/\/+$/, "")
  : typeof window !== "undefined" &&
      window.location.hostname !== "localhost" &&
      window.location.hostname !== "127.0.0.1"
    ? ""
    : "http://localhost:8080";

export const AUTH_URLS = {
  yandexLogin: `${API_BASE_URL}/auth/yandex`,
  me: `${API_BASE_URL}/api/me`,
  logout: `${API_BASE_URL}/auth/logout`,
  yandexCallback: `${API_BASE_URL}/auth/yandex/callback`,
};
